// 定义一个地理位置的全局状态管理
export default {
    namespaced: true,
    state: () => ({
      province: '',     // 省
      city: '',         // 市
      district: '',     // 区
      longitude: null,  // 经度
      latitude: null,   // 纬度
      cityCode: '',     // 城市行政编码
      address: ''       // 详细地址
    }),
    mutations: {
      // 设置省市区
      setArea(state, { province, city, district }) {
        state.province = province
        state.city = city
        state.district = district
      },
      // 设置经纬度
      setCoordinates(state, { longitude, latitude }) {
        state.longitude = longitude
        state.latitude = latitude
      },
      // 设置城市编码
      setCityCode(state, code) {
        state.cityCode = code
      },
      // 设置详细地址
      setAddress(state, address) {
        state.address = address
      },
      // 批量更新定位信息
      setLocation(state, payload) {
        Object.assign(state, payload)
      }
    },
    actions: {
      // 这里可以添加异步定位操作（根据您现有的定位方法）
    }
  }